<template>
  <div class="page-wrap RTEAO-report" ref="containerRef">
    <MCard title="上报记录" :loading="loading" title-align="center">
      <MForm v-bind="form" :dataSource="dataSource" />

      <MTable v-bind="tableConfig" @search="initData">
        <template #video="{ value, row }">
          <ElButton :disabled="!value" size="medium" type="primary" @click="handlePlay(row)">
            播放
          </ElButton>
        </template>
      </MTable>
    </MCard>
  </div>
</template>

<script>
import MForm from '@/components/form/v2.vue';
import MTable from '@/components/mTable/m-table.vue';
import MCard from '@/components/mCard/index.vue';
import { getReportList } from '@/api/RTEAO';
import { formatTime } from '@/utils/date';
import { filterNonEmptyValues } from '@/utils/utils';
import { mapState } from 'vuex';

import { useDialog } from '@/components/dialog';

export default {
  components: {
    MForm,
    MTable,
    MCard
  },
  inject: ['nodeList'],
  data() {
    return {
      loading: false,
      form: {
        config: {
          formProps: {
            inline: true,
            labelSuffix: ':'
          },
          formAttrs: {
            style: 'padding: 15px 20px;'
          }
        },
        options: [
          {
            label: '节点',
            type: 'select',
            prop: 'node',
            componentProps: {
              popperAppendToBody: false,
              multiple: true,
              clearable: true,
              placeholder: '请选择节点',
              collapseTags: true,
              filterable: true,
              props: {
                label: 'name',
                value: 'id'
              }
            },
            dataKey: 'nodeList'
          },
          {
            label: '时间',
            type: 'datePicker',
            prop: 'time',
            componentProps: {
              appendToBody: false,
              clearable: true,
              type: 'daterange',
              rangeSeparator: '-',
              startPlaceholder: '开始日期',
              endPlaceholder: '结束日期',
              valueFormat: 'timestamp'
            }
          }
        ],
        operations: {
          attrs: {
            style: 'margin-left: 10px; width: 120px; display: inline-block;'
          },
          list: [
            {
              text: '查询',
              loading: false,
              buttonProps: {
                type: 'primary'
              },
              onClick: async (_, btn) => {
                btn.loadiing = true;

                await this.initData();

                btn.loadiing = false;
              }
            }
          ]
        },
        model: {
          node: [],
          time: []
        }
      },
      tableConfig: {
        height: '100%',
        tableData: [
          {
            reportTime: '2020-08-01 10:00:00',
            positiveCount: 10,
            testingCompany: '公司A',
            samplingPoint: 'xxx'
          }
        ],
        tableColumn: [
          {
            label: '采样时间',
            prop: 'sampleStartTime',
            temp: ({ row }) => {
              return formatTime(row.sampleStartTime, 'yyyy-MM-dd hh:mm');
            }
          },
          {
            label: '节点',
            prop: 'officeName'
          },
          {
            label: '哨点',
            prop: 'name'
          },
          {
            label: '检测机构',
            prop: 'sampleTestOrg'
          },
          {
            label: '检测试剂',
            prop: 'sampleDetectionReagent'
          },
          {
            label: '检测设备',
            prop: 'sampleTestDevice'
          },
          {
            label: '样品存储位置',
            prop: 'sampleStorageLocation'
          },
          {
            label: '采样视频',
            prop: 'sampleVideo',
            slot: 'video'
          }
        ],
        pagiOption: {
          offset: 1,
          limit: 10,
          total: 0,
          pagiSize: [10, 15, 20, 30, 100, 200],
          layout: 'total, sizes, prev, pager, next, jumper'
        }
      }
    };
  },
  computed: {
    ...mapState('socket', ['deviceTree']),
    dataSource() {
      return {
        nodeList: this.nodeList
      };
    }
  },
  methods: {
    handlePlay(e) {
      useDialog({
        title: `采样视频(${e.sn})`,
        width: '1000px',
        marginTop: '200px',
        appendToBody: false,
        container: this.$refs.containerRef,
        style: 'border: 1px solid rgba(12, 106, 182, 0.8);',
        modal: false,
        slots: {
          default: () => (
            <div style="width: 100%; height: 500px;">
              <video controls style="width: 100%; height: 100%;">
                <source src={e.sampleVideo} type="video/mp4" />
              </video>
            </div>
          )
        }
      });
    },
    async initData() {
      try {
        this.loading = true;

        const res = await getReportList(
          filterNonEmptyValues({
            officeIds: this.form.model.node,
            beginTimestamp: this.form.model?.time?.[0],
            endTimestamp: this.form.model?.time?.[1],
            limit: this.tableConfig.pagiOption.limit,
            offset: this.tableConfig.pagiOption.offset
          })
        );

        if (res.code !== 200) return;

        this.tableConfig.pagiOption.total = res.data.total;
        this.tableConfig.tableData = res.data.list;
        this.tableConfig.pagiOption.total = res.data.total;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.initData();
  }
};
</script>

<style lang="scss">
.RTEAO-report {
  .m-table {
    height: calc(100% - 182px);
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form {
    &-item {
      &__label {
        font-size: 1rem;

        line-height: 2.2rem;
      }

      &__content {
        .el-input {
          font-size: 1rem;
        }

        .el-select {
          .el-input__inner {
            height: 2.2rem !important;
          }

          .el-select__input {
            font-size: 1rem;
          }
        }

        .el-select-dropdown__item {
          font-size: 1rem;
          height: 2rem;
          line-height: 2rem;
        }

        .el-date-table {
          font-size: 0.8rem;
        }

        .el-date-editor {
          .el-range__icon {
            font-size: 1rem;
          }
        }

        .el-range-editor.el-input__inner {
          height: 2.2rem;
        }

        .el-range-input {
          font-size: 1rem;
        }

        .el-date-range-picker__header {
          .el-picker-panel__icon-btn {
            font-size: 0.8rem;
          }

          div {
            font-size: 1rem;
          }
        }
      }
    }
  }

  .el-button {
    font-size: 1rem;
    width: 6.5rem;

    height: 2.2rem;
    line-height: 2.2rem;
    padding: 0 1rem;
  }
}
</style>
